import { styled } from 'styled-components';
import { scrollbar } from 'theme';

export const ScrollableContainer = styled.div`
  ${scrollbar}
  height: calc(100vh - 114px);
  padding-inline: ${({ theme }) => theme.spacing(4)};
  overflow: auto;
`;
